import { createBox } from '@mui/system';
import { createTheme } from '../styles';
const defaultTheme = createTheme();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme
});
export default Box;